// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './ind.vue'
import 'lib-flexible'
import VueRouter from 'vue-router'
import Index from './components/ind.vue'
import Info from './components/info.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Mint from 'mint-ui';
import 'mint-ui/lib/style.css'

// import Vconsole from 'vconsole';

Vue.use(VueRouter,Mint)
import { Swipe, SwipeItem,Popup,Checklist } from 'mint-ui';
Vue.component(Checklist.name, Checklist);
Vue.component(Swipe.name, Swipe);
Vue.component(Popup.name, Popup);
Vue.component(SwipeItem.name, SwipeItem);
Vue.prototype.$axios = axios

const router = new VueRouter({
  routes: [
    // 动态路径参数 以冒号开头
    {
      path: '/',
      name: 'index',
      component: Index
    },
    {
      path: '/info',
      name: 'info',
      component: Info
    }

  ]
})

Vue.config.productionTip = false
// new Vconsole();

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/pages/index1/ind.js